import { Tag } from '../../shared/tags/tag.model';
import { Social } from '../../shared/social/social.model';
import { Note } from '../../shared/notes/note.model';
import { Communication } from '../../shared/communications/communication.model';
import { Contact } from '../contacts/contact.model';
import { Project } from '../projects/project.model';
import { TeamMember } from '../team/team.model';
import { Purchase } from '../projects/purchase.model';
import { EventBB } from '../events/event.model';
import { Task } from '../../shared/tasks/task.model';
import { Attachment } from '../../shared/attachments/attachment.model';

export class Company {
  _id?: string;
  // reference: number;

  /* Basic Company Information */
  companyName?: string;
  domain?: string;
  cleanDomain?: string;
  logoUrl?: string;
  telephone?: string;
  fax?: string;
  email?: string;
  summary?: string;

  /* key stats */
  revenue?: number = 0;
  noOfEmployees?: number;

  /* company relationship details */
  // referrers: Contact[] = [];
  blueboxContacts: TeamMember[] = [];
  referrer?: Contact;

  opportunitySource: string;
  industryType: string;
  businessRelationship: string;

  /* Company Types */
  isContact?: boolean = true;
  isOpportunity?: boolean;
  isClient?: boolean;
  isBuyer?: boolean;
  isLawyer?: boolean;
  isReferrer?: boolean;
  isClinicHost?: boolean;
  isAccountant?: boolean;
  isSupplier?: boolean;

  // Ambassador
  isAmbassador?: boolean = false;
  hasSignedAmbassadorNDA?: boolean = false;

  // investment interest
  investmentTypes?: string[] = [];
  investorTypes?: string[] = [];
  investmentPreferredDealTypes?: string[] = [];
  investmentGeographicalPreferences?: string[] = [];
  investmentPreferredIndustries?: string[] = [];
  investmentPreferredCompanyValuations?: string[] = [];
  investmentPreferredInvestmentAmounts?: string[] = [];
  investmentPreferredRevenueCharacteristics?: string[] = [];
  investmentPreferredProfitCharacteristics?: string[] = [];
  investmentNotes?: string = '';

  /* not sure on this yet */
  // googlePlaceInfo: google.maps.places.PlaceResult;

  /* other objects */
  sales?: Project[] = [];
  purchases?: Purchase[] = [];
  attachments?: Attachment[] = [];
  // purchase?: Project[];
  employees?: Contact[] = [];
  // address: Address = new Address();
  social?: Social;
  events?: EventBB[] = [];
  communications?: Communication[] = [];
  notes?: Note[] = [];
  tasks?: Task[] = [];
  tags?: Tag[];

  // Main Address
  line1?: string = '';
  line2?: string = '';
  city?: string = '';
  postcode?: string = '';
  county?: string = '';
  country?: string = '';

  // Alternative address
  otherLine1?: string = '';
  otherLine2?: string = '';
  otherCity?: string = '';
  otherPostcode?: string = '';
  otherCounty?: string = '';
  otherCountry?: string = '';

  // Contact Preferences
  doNotContact?: boolean = false;

  constructor(name?: string, domain?: string, logoURL?: string) {
    this.companyName = name;
    this.domain = domain;
    this.logoUrl = logoURL;
  }


  filterQueryCreate(filterStrings: string[] = []) {

    const filterQuery = Object.entries(this)
      .filter(([key, value]) => (( !Array.isArray(value) && value ) || ( Array.isArray(value) && value.length > 0 ))) // filters out the blanks and zero arrays
      .map(
        ([key, value]) => {

          if ( value === true || value === false ) {
            return `${key}=${value}`; // for true/false types we want to do this
          } else if ( Array.isArray(value)  ) {
            // const arraySplit = value.join(',');
            return `${key}=${value}`; // this lets us do a like query
          } else {
            return `${key}=%2F${value}%2Fi`; // this lets us do a like query
          }
        }
      ).join('&');

    // console.log('Filter Query', filterQuery);

    return filterQuery;

  }

}



// WEBPACK FOOTER //
// ./client/app/features/companies/company.model.ts